import { createFileRoute } from '@tanstack/react-router';
import { TranscriptPage } from '../../../pages/tools/transcript/TranscriptPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/instagram-transcript')({
  head: () => toolHead('instagram-transcript'),
  component: () => <TranscriptPage platform="instagram" />,
});
